import Vue from 'vue';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { _USER_REQUESTS_STORE, MUTATIONS } from '../values/user-requests.values';
import { STATUS_TYPES } from '../values/user-requests.values';
import { GetUserRequestsParams } from '../params/user-requests.params';

export const USER_REQUESTS_STORE = _USER_REQUESTS_STORE; 

@Module({ namespaced: true })
export class UserRequestsStore extends VuexModule {

  /* State */
  public pendingUsers: Array<Object> = [];
  public approvedUsers: Array<Object> = [];
  public rejectedUsers: Array<Object> = [];

  /* Mutations */
  @Mutation
  public setPendingUsersM(users){
    let content = users.content
    let page = users.number
    this.pendingUsers = [...this.pendingUsers, {page, content}]
  }

  @Mutation
  public setApprovedUsersM(users){
    let content = users.content
    let page = users.number
    this.approvedUsers = [...this.approvedUsers, {page, content}]
  }

  @Mutation
  public setRejectedUsersM(users){
    let content = users.content
    let page = users.number
    this.rejectedUsers = [...this.rejectedUsers, {page, content}]
  }

  @Mutation
  public resetUserRequestsM(){
    this.pendingUsers = []
    this.approvedUsers = []
    this.rejectedUsers = []
  }

  /* Actions */
  @Action({rawError:true})
  public async getUserRequestsA(data: GetUserRequestsParams): Promise<any>{
    const res  = await Vue.prototype.$UserRequests.Services.getUserRequests(data);
    if (data.status == STATUS_TYPES.PENDING)
      this.context.commit(MUTATIONS.SET_PENDING_USERS_M, res);
    else if (data.status == STATUS_TYPES.APPROVED)
      this.context.commit(MUTATIONS.SET_APPROVED_USERS_M, res);
    else if (data.status == STATUS_TYPES.REJECTED)
      this.context.commit(MUTATIONS.SET_REJECTED_USERS_M, res);
    return res
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.pendingUsers = [];
    this.approvedUsers = [];
    this.rejectedUsers = [];
  }
}